import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {MatDialog} from "@angular/material";
import {Term} from "../../../../../classes/term";
import {kanTermDialog} from "../../../dialogs/term-dialog/component";

@Component({
    selector: 'kan-term-list-item',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanTermListItem {
    @Input() term: Term;
    @Output() refresh: EventEmitter<any> = new EventEmitter();

    constructor(                private dialog: MatDialog) {
    }

    ngOnInit(): void {

    }

    public edit(event) {
        let dialogRef = this.dialog.open(kanTermDialog, {
            data: {
                term: this.term
            },
            disableClose: true,
            width: '800px'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'update') {
                this.refresh.emit();
            }
        });
    }

    public remove(event) {
        // let dialogRef = this.dialog.open(kanRemoveDialog, {
        //     disableClose: true
        // });
        //
        // dialogRef.afterClosed().subscribe((result) => {
        //     if (result === 'remove') {
        //         this.termsService.removeTerm(this.term)
        //             .then((data) => {
        //                 this.refresh.emit();
        //             });
        //     }
        // });
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/term/list-item/component.ts